import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";

export default class Logo{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-logo-wrap'});
        if(this.ds.config.isCsInfoNCVVN){
          tmpl.classList.add('footer-logo-wrap_pc-view');
        }

        if(this.ds.config.isKakaoGamesChannel){
            tmpl.innerHTML= `
            <a class="footer-logo ncsoft" href="${this.ds.config.companyLink}" target="_blank">NC</a>
            <a class="footer-logo kakaogames-channel" href="http://www.kakaogames.com" target="_blank">KAKAO GAMES</a>
            `;
        }else if(this.ds.config.isCsInfoBreakers){
            tmpl.classList.add('footer-logo-wrap_breakers');
            tmpl.innerHTML= `
            <div class="footer-logo breakers-vic-studios">VIC GAME STUDIOS</div>
            <div class="footer-logo ncsoft">NC</div>
            <div class="footer-logo breakers-kadokawa">KADOKAWA</div>
            `;
        }else if(this.ds.config.isCsInfoNCVVN){
            const ncvVnLicenseUrl = this.ds.service === 'lineagewsa'
              ? 'https://giayphep.abei.gov.vn/g1/131809'
              : 'https://giayphep.abei.gov.vn/g1/131930';
            tmpl.innerHTML= `
            <a href="${ncvVnLicenseUrl}" target="_blank">
              <div class="footer-logo ncv-vn-ncsoft" href="${this.ds.config.companyLink}" target="_blank">NC</div>
            </a>`;
        }else if(this.ds.config.isCsInfoNCV){
            tmpl.innerHTML= `
            <div class="footer-logo ncv-ncsoft" href="${this.ds.config.companyLink}" target="_blank">NC</div>`;
        }else if(this.ds.country === 'KR'){
            tmpl.innerHTML= `
            <a class="footer-logo ncsoft" href="${this.ds.config.companyLink}" target="_blank">NC</a>
            `;
        } else{
            tmpl.innerHTML= `
            <a class="footer-logo ncsoft" href="${this.ds.config.companyLink}" target="_blank">NC</a>
            `;
        }

        // if(document.documentElement.dataset.service === 'tl'){
        // 임시
        if(this.ds.config.isCsInfoFirstSpark){
          if(document.documentElement.lang === 'ko'){
            tmpl.innerHTML+= `
            <a class="footer-logo first-spark" href="https://firstsparkgames.com/ko" target="_blank">FIRST SPARK</a>
            `;
          }else{
            tmpl.innerHTML+= `
            <a class="footer-logo first-spark" href="https://firstsparkgames.com/en" target="_blank">FIRST SPARK</a>
            `;
          }
        }
    }
}
